import { render, staticRenderFns } from "./BuilderPalette.vue?vue&type=template&id=6bd542c6&scoped=true"
import script from "./BuilderPalette.vue?vue&type=script&lang=js"
export * from "./BuilderPalette.vue?vue&type=script&lang=js"
import style0 from "./BuilderPalette.vue?vue&type=style&index=0&id=6bd542c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd542c6",
  null
  
)

export default component.exports